import type { ToastType, ToastData } from "./toast";

/**
 * Extracts toast data from URL search params (client-side only)
 */
export function getToastFromParams(searchParams: URLSearchParams): ToastData | null {
  const type = searchParams.get("toast_type") as ToastType;
  const title = searchParams.get("toast_title");
  const description = searchParams.get("toast_description");

  if (!type || !title) return null;

  return {
    type,
    title,
    description: description || undefined,
  };
}
